const discussionLoaded = state => state.discussionLoaded;
const leaderboardLoaded = state => state.leaderboardLoaded;
const aggregateLoaded = state => state.aggregateLoaded;
const joining = state => state.joining;
const allChallengePackages = state => state.allChallengePackages;
const challengePackagesForBuilder = state => state.challengePackagesForBuilder;
const packagesLoaded = state => state.packagesLoaded;
const getDiscussionById = state => id => state["discussion" + id] || {};
const getAggregateById = state => id => state["aggregate" + id];
const getLeaderboardById = state => (id, key = "data", organization = 0) => {
  let empty = key === "pagination" ? {} : [];
  const leaderboardString = organization
    ? "organizationLeaderboard"
    : "leaderboard";
  let leaderboardResponseObject = state[leaderboardString + id];
  if (leaderboardResponseObject && key in leaderboardResponseObject) {
    return leaderboardResponseObject[key];
  }
  return empty;
};
const getChallengeById = state => id => state["challenge" + id] || {};
const sentChallengeInvites = state => state.sentChallengeInvites;
const allMembersInvited = state => state.allMembersInvited;
const refreshJoinedStatusNeeded = state => state.refreshJoinedStatusNeeded;
const mobileChallenge = state => state.mobileChallenge;
const mobileChallengeLoaded = state => state.mobileChallengeLoaded;

export default {
  discussionLoaded,
  leaderboardLoaded,
  aggregateLoaded,
  joining,
  allChallengePackages,
  challengePackagesForBuilder,
  packagesLoaded,
  getDiscussionById,
  getAggregateById,
  getLeaderboardById,
  getChallengeById,
  sentChallengeInvites,
  allMembersInvited,
  refreshJoinedStatusNeeded,
  mobileChallenge,
  mobileChallengeLoaded
};
